module.exports = __webpack_public_path__ + "static/media/pic13.c58045e0.jpg";